export default "__VITE_ASSET__CokZv_EK__"